export default "__VITE_ASSET__871d29e3__$_?component__"